module.exports = __webpack_public_path__ + "static/media/dashboard_active.dc1f95e8.svg";